module.exports = __webpack_public_path__ + "static/media/banner_1920x350-4.90df2f6b.jpg";